module.exports = __webpack_public_path__ + "img/practice-1.518b6cda.jpg";